// tslint:disable:max-file-line-count
// tslint:disable:object-literal-key-quotes
// TODO: Make async (JSON file)
import Bluebird from 'bluebird';
import { inArray } from '../../../services/arrays';

// Source: http://country.io/currency.json
export const currencyOfCountry: { [country: string]: string } = {
    'BD': 'BDT',
    'BE': 'EUR',
    'BF': 'XOF',
    'BG': 'BGN',
    'BA': 'BAM',
    'BB': 'BBD',
    'WF': 'XPF',
    'BL': 'EUR',
    'BM': 'BMD',
    'BN': 'BND',
    'BO': 'BOB',
    'BH': 'BHD',
    'BI': 'BIF',
    'BJ': 'XOF',
    'BT': 'BTN',
    'JM': 'JMD',
    'BV': 'NOK',
    'BW': 'BWP',
    'WS': 'WST',
    'BQ': 'USD',
    'BR': 'BRL',
    'BS': 'BSD',
    'JE': 'GBP',
    'BY': 'BYR',
    'BZ': 'BZD',
    'RU': 'RUB',
    'RW': 'RWF',
    'RS': 'RSD',
    'TL': 'USD',
    'RE': 'EUR',
    'TM': 'TMT',
    'TJ': 'TJS',
    'RO': 'RON',
    'TK': 'NZD',
    'GW': 'XOF',
    'GU': 'USD',
    'GT': 'GTQ',
    'GS': 'GBP',
    'GR': 'EUR',
    'GQ': 'XAF',
    'GP': 'EUR',
    'JP': 'JPY',
    'GY': 'GYD',
    'GG': 'GBP',
    'GF': 'EUR',
    'GE': 'GEL',
    'GD': 'XCD',
    'GB': 'GBP',
    'GA': 'XAF',
    'SV': 'USD',
    'GN': 'GNF',
    'GM': 'GMD',
    'GL': 'DKK',
    'GI': 'GIP',
    'GH': 'GHS',
    'OM': 'OMR',
    'TN': 'TND',
    'JO': 'JOD',
    'HR': 'HRK',
    'HT': 'HTG',
    'HU': 'HUF',
    'HK': 'HKD',
    'HN': 'HNL',
    'HM': 'AUD',
    'VE': 'VEF',
    'PR': 'USD',
    'PS': 'ILS',
    'PW': 'USD',
    'PT': 'EUR',
    'SJ': 'NOK',
    'PY': 'PYG',
    'IQ': 'IQD',
    'PA': 'PAB',
    'PF': 'XPF',
    'PG': 'PGK',
    'PE': 'PEN',
    'PK': 'PKR',
    'PH': 'PHP',
    'PN': 'NZD',
    'PL': 'PLN',
    'PM': 'EUR',
    'ZM': 'ZMK',
    'EH': 'MAD',
    'EE': 'EUR',
    'EG': 'EGP',
    'ZA': 'ZAR',
    'EC': 'USD',
    'IT': 'EUR',
    'VN': 'VND',
    'SB': 'SBD',
    'ET': 'ETB',
    'SO': 'SOS',
    'ZW': 'ZWL',
    'SA': 'SAR',
    'ES': 'EUR',
    'ER': 'ERN',
    'ME': 'EUR',
    'MD': 'MDL',
    'MG': 'MGA',
    'MF': 'EUR',
    'MA': 'MAD',
    'MC': 'EUR',
    'UZ': 'UZS',
    'MM': 'MMK',
    'ML': 'XOF',
    'MO': 'MOP',
    'MN': 'MNT',
    'MH': 'USD',
    'MK': 'MKD',
    'MU': 'MUR',
    'MT': 'EUR',
    'MW': 'MWK',
    'MV': 'MVR',
    'MQ': 'EUR',
    'MP': 'USD',
    'MS': 'XCD',
    'MR': 'MRO',
    'IM': 'GBP',
    'UG': 'UGX',
    'TZ': 'TZS',
    'MY': 'MYR',
    'MX': 'MXN',
    'IL': 'ILS',
    'FR': 'EUR',
    'IO': 'USD',
    'SH': 'SHP',
    'FI': 'EUR',
    'FJ': 'FJD',
    'FK': 'FKP',
    'FM': 'USD',
    'FO': 'DKK',
    'NI': 'NIO',
    'NL': 'EUR',
    'NO': 'NOK',
    'NA': 'NAD',
    'VU': 'VUV',
    'NC': 'XPF',
    'NE': 'XOF',
    'NF': 'AUD',
    'NG': 'NGN',
    'NZ': 'NZD',
    'NP': 'NPR',
    'NR': 'AUD',
    'NU': 'NZD',
    'CK': 'NZD',
    'XK': 'EUR',
    'CI': 'XOF',
    'CH': 'CHF',
    'CO': 'COP',
    'CN': 'CNY',
    'CM': 'XAF',
    'CL': 'CLP',
    'CC': 'AUD',
    'CA': 'CAD',
    'CG': 'XAF',
    'CF': 'XAF',
    'CD': 'CDF',
    'CZ': 'CZK',
    'CY': 'EUR',
    'CX': 'AUD',
    'CR': 'CRC',
    'CW': 'ANG',
    'CV': 'CVE',
    'CU': 'CUP',
    'SZ': 'SZL',
    'SY': 'SYP',
    'SX': 'ANG',
    'KG': 'KGS',
    'KE': 'KES',
    'SS': 'SSP',
    'SR': 'SRD',
    'KI': 'AUD',
    'KH': 'KHR',
    'KN': 'XCD',
    'KM': 'KMF',
    'ST': 'STD',
    'SK': 'EUR',
    'KR': 'KRW',
    'SI': 'EUR',
    'KP': 'KPW',
    'KW': 'KWD',
    'SN': 'XOF',
    'SM': 'EUR',
    'SL': 'SLL',
    'SC': 'SCR',
    'KZ': 'KZT',
    'KY': 'KYD',
    'SG': 'SGD',
    'SE': 'SEK',
    'SD': 'SDG',
    'DO': 'DOP',
    'DM': 'XCD',
    'DJ': 'DJF',
    'DK': 'DKK',
    'VG': 'USD',
    'DE': 'EUR',
    'YE': 'YER',
    'DZ': 'DZD',
    'US': 'USD',
    'UY': 'UYU',
    'YT': 'EUR',
    'UM': 'USD',
    'LB': 'LBP',
    'LC': 'XCD',
    'LA': 'LAK',
    'TV': 'AUD',
    'TW': 'TWD',
    'TT': 'TTD',
    'TR': 'TRY',
    'LK': 'LKR',
    'LI': 'CHF',
    'LV': 'EUR',
    'TO': 'TOP',
    'LT': 'LTL',
    'LU': 'EUR',
    'LR': 'LRD',
    'LS': 'LSL',
    'TH': 'THB',
    'TF': 'EUR',
    'TG': 'XOF',
    'TD': 'XAF',
    'TC': 'USD',
    'LY': 'LYD',
    'VA': 'EUR',
    'VC': 'XCD',
    'AE': 'AED',
    'AD': 'EUR',
    'AG': 'XCD',
    'AF': 'AFN',
    'AI': 'XCD',
    'VI': 'USD',
    'IS': 'ISK',
    'IR': 'IRR',
    'AM': 'AMD',
    'AL': 'ALL',
    'AO': 'AOA',
    'AS': 'USD',
    'AR': 'ARS',
    'AU': 'AUD',
    'AT': 'EUR',
    'AW': 'AWG',
    'IN': 'INR',
    'AX': 'EUR',
    'AZ': 'AZN',
    'IE': 'EUR',
    'ID': 'IDR',
    'UA': 'UAH',
    'QA': 'QAR',
    'MZ': 'MZN'
};

let countryCodes;
function getCountryCodes(): Bluebird<string[]> {
    if (!countryCodes) {
        // TODO: Replace with XHR call
        countryCodes = ['AFG', 'AX', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AI', 'AQ', 'AG', 'AR', 'AM',
            'AW', 'AU', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BQ', 'BA', 'BW',
            'BV', 'BR', 'IO', 'BN', 'BG', 'BF', 'BI', 'CV', 'KH', 'CM', 'CA', 'KY', 'CF', 'TD', 'CL', 'CN', 'CX', 'CC',
            'CO', 'KM', 'CD', 'CG', 'CK', 'CR', 'CI', 'HR', 'CU', 'CW', 'CY', 'CZ', 'DK', 'DJ', 'DM', 'DO', 'EC', 'EG',
            'SV', 'GQ', 'ER', 'EE', 'ET', 'FK', 'FO', 'FJ', 'FI', 'FR', 'GF', 'PF', 'TF', 'GA', 'GM', 'GE', 'DE', 'GH',
            'GI', 'GR', 'GL', 'GD', 'GP', 'GU', 'GT', 'GG', 'GN', 'GW', 'GY', 'HT', 'HM', 'VA', 'HN', 'HK', 'HU', 'IS',
            'IN', 'ID', 'IR', 'IQ', 'IE', 'IM', 'IL', 'IT', 'JM', 'JP', 'JE', 'JO', 'KZ', 'KE', 'KI', 'KP', 'KR', 'KW',
            'KG', 'LA', 'LV', 'LB', 'LS', 'LR', 'LY', 'LI', 'LT', 'LU', 'MO', 'MK', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT',
            'MH', 'MQ', 'MR', 'MU', 'YT', 'MX', 'FM', 'MD', 'MC', 'MN', 'ME', 'MS', 'MA', 'MZ', 'MM', 'NA', 'NR', 'NP',
            'NL', 'NC', 'NZ', 'NI', 'NE', 'NG', 'NU', 'NF', 'MP', 'NO', 'OM', 'PK', 'PW', 'PS', 'PA', 'PG', 'PY', 'PE',
            'PH', 'PN', 'PL', 'PT', 'PR', 'QA', 'RE', 'RO', 'RU', 'RW', 'BL', 'SH', 'KN', 'LC', 'MF', 'PM', 'VC', 'WS',
            'SM', 'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SX', 'SK', 'SI', 'SB', 'SO', 'ZA', 'GS', 'SS', 'ES', 'LK',
            'SD', 'SR', 'SJ', 'SZ', 'SE', 'CH', 'SY', 'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TK', 'TO', 'TT', 'TN', 'TR',
            'TM', 'TC', 'TV', 'UG', 'UA', 'AE', 'GB', 'UM', 'US', 'UY', 'UZ', 'VU', 'VE', 'VN', 'VG', 'VI', 'WF', 'EH',
            'YE', 'ZM', 'ZW'];
    }

    return Bluebird.resolve(countryCodes);
}

export function isCountryCode(code: string): Bluebird<boolean> {
    return getCountryCodes().then(codes => inArray(code, codes));
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/resources.ts